<template>
	<div>
		<!-- <img alt="Vue logo" src="./assets/logo.png"> -->
		<!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
		<CreateRoom />
		<hr />
		<JoinRoom />
		<hr />
		<ReenterRoom />
	</div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import CreateRoom from '@/components/CreateRoom.vue';
import JoinRoom from '@/components/JoinRoom.vue';
import ReenterRoom from '@/components/ReenterRoom.vue';

export default {
	name: 'Home',
	components: {
		// HelloWorld,
		CreateRoom,
		JoinRoom,
		ReenterRoom,
	},
};
</script>
